import lottie from "lottie-web";
import { isPageAtTop, isScrollingUp } from "../utility/utility";

class IllustrationHeaderLogo extends HTMLElement {
  constructor() {
    super();
    this.isAnimationPlaying = false;
  }

  connectedCallback() {
    this.initElements();
    this.initLottieAnimation();
    this.addEventListeners();
    this.handleScroll();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  initElements() {
    this.logoOuterContainer = this.querySelector(".logo-outer-container");
    this.logoIcon = this.querySelector(".logo-icon-container"); // Move it here
    this.hingeElement = this.querySelector(".hinge");
    this.nabohjaelpText = this.querySelector(".nabohjaelp-text");
    this.nabohjaelpTextRight = this.querySelector(".nabohjaelp-text-right");
    this.hingeElement.addEventListener("animationend", this.hingeAnimationEnd);
    this.transitionEndHandler = this.transitionEndHandler.bind(this);
    this.logoOuterContainer.addEventListener("transitionend", this.transitionEndHandler);
    this.hingeContainer = this.querySelector(".logo-hinge-container");
  }

  initLottieAnimation() {
    if (!this.logoAnimation) {
      this.logoAnimation = lottie.loadAnimation({
        container: this.logoIcon,
        path: "/dist/lottie/Logo-Symbol.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
      });
      this.logoAnimation.addEventListener("complete", () => {
        this.isAnimationPlaying = false;
      });
    }
  }

  addEventListeners() {
    this.logoIcon.addEventListener("mouseover", this.handleMouseOver);
    window.addEventListener("scroll", this.handleScroll);
    this.initDropdownToggleListeners();
    this.handleScroll();
  }

  cleanup() {
    this.logoAnimation?.destroy();
    this.logoIcon.removeEventListener("mouseover", this.handleMouseOver);
    window.removeEventListener("scroll", this.handleScroll);
    this.hingeElement.removeEventListener("animationend", this.hingeAnimationEnd);
    this.logoOuterContainer.removeEventListener("transitionend", this.transitionEndHandler);
  }

  handleMouseOver = () => {
    if (!this.isAnimationPlaying) {
      this.logoAnimation.goToAndPlay(0, true);
      this.isAnimationPlaying = true;
    }
  };

  handleScroll = () => {
    if (!this.isDropdownOpen()) {
      if (isPageAtTop()) {
        this.animatePageAtTop();
      } else if (isScrollingUp()) {
        this.animateScrollingUp();
      } else {
        this.animateScrollingDown();
      }
    }
  };

  animatePageAtTop = () => {
    this.applyClassChanges(this.logoOuterContainer, ["ml-6"], ["-ml-8"]);
    this.applyClassChanges(this.nabohjaelpTextRight, ["opacity-0"], ["opacity-100"]);
  };

  animateScrollingUp = () => {
    this.logoIcon.style.height = "48px";
    this.applyClassChanges(this.nabohjaelpTextRight, ["opacity-100", "scale-125", "-translate-x-5"], ["opacity-0", "-translate-x-6"]);
  };

  animateScrollingDown = () => {
    this.logoIcon.style.height = "38px";
    this.applyClassChanges(this.hingeElement, ["logo-hinge-animation"], ["logo-hinge-animation-reverse"]);
    this.applyClassChanges(this.nabohjaelpText, ["opacity-0"], ["opacity-100"]);
    this.applyClassChanges(this.nabohjaelpTextRight, ["opacity-100", "-translate-x-6"], ["opacity-0", "scale-125", "-translate-x-5"]);
  };

  hingeAnimationEnd = () => {
    if (this.hingeElement.classList.contains("logo-hinge-animation") && !isPageAtTop()) {
      this.applyClassChanges(this.logoOuterContainer, ["-ml-8"], ["ml-6"]);
      this.applyClassChanges(this.hingeContainer, ["pointer-events-none"], ["pointer-events-auto"]);
    }
  };

  transitionEndHandler(event) {
    if (event.propertyName === "margin-left") {
      this.textAnimationEnd();
    }
  }

  textAnimationEnd = () => {
    if (isPageAtTop() && this.logoOuterContainer.classList.contains("ml-6")) {
      this.logoIcon.style.height = "";
      this.hingeElement.classList.add("logo-hinge-animation-reverse");
      this.applyClassChanges(this.nabohjaelpTextRight, ["-translate-x-5"], ["scale-125", "-translate-x-6"]);
      this.applyClassChanges(this.nabohjaelpText, ["opacity-100"], ["hidden", "opacity-0"]);
    }
  };

  dropdownOpenAnimation = () => {
    if (this.isDropdownOpen()) {
      if (this.logoAnimation.isLoaded && this.isAnimationPlaying) {
        this.logoAnimation.pause();
      }
    } else {
      if (this.logoAnimation.isLoaded && !this.isAnimationPlaying) {
        this.logoAnimation.play();
      }
    }
  };

  isDropdownOpen() {
    return !!document.querySelector(".main-nav__dropdown.is-open");
  }

  initDropdownToggleListeners() {
    document.addEventListener("click", (event) => {
      if (event.target.matches(".js-toggle-mega-nav")) {
        this.dropdownOpenAnimation();
      }
    });
  }

  applyClassChanges(element, classesToAdd = [], classesToRemove = []) {
    // First, remove classes that are no longer needed
    classesToRemove.forEach((className) => {
      if (element.classList.contains(className)) {
        element.classList.remove(className);
      }
    });

    // Then add classes that are needed
    classesToAdd.forEach((className) => {
      if (!element.classList.contains(className)) {
        element.classList.add(className);
      }
    });
  }
}

customElements.define("nabohjaelp-illustration-header-logo", IllustrationHeaderLogo);
